/******************************************************************/
/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
/******************************************************************/

angular.module('app.LawyerProfile').controller('locationModalController' , locationModalController);

function locationModalController($scope, $http, $log, $modalInstance, $location, data, $translate, logger) {
      $translate.use('en');
      $scope.notify = function(type, message) {
        switch (type) {
          case 'info':
            logger.log(message);
            break;
          case 'success':
            logger.logSuccess(message);
            break;
          case 'warning':
            logger.logWarning(message);
            break;
          case 'error':
            logger.logError(message);
        }
      };

      $scope.count = 0;
      $scope.data = data.data;
      const isModalForHistorylocations = data.isModalForHistorylocations;
      $scope.showLocations = true;
      $scope.element = data.element;
      $log.info("$scope.data",$scope.data);
      if (isModalForHistorylocations)
      {
        $scope.heading = "modal.employmentHistory.locations.Heading";
        $scope.subHeading = "modal.employmentHistory.locations.subHeading";
      }
      else
      {
        $scope.heading = 'modal.locations.Heading';
        $scope.subHeading = "Show locations";
      }

      $scope.isLocAlreadySelected = data.isLocAlreadySelected;
      $scope.updatedData = {
        data: $scope.data,
        element: ''
      };
      $scope.showChildLocations = false;

      $scope.displayChildLocations = function(region) {
        region.showChildLocations = true;
      };
      $scope.hideChildLocations = function(region) {
        region.showChildLocations = false;
      };

      $scope.selectLocation = function(event, current, level) {

        var pCounter, sCounter, value;
        pCounter = 0;
        sCounter = 0;
        $scope.updatedData.element = 'location';
        value = event.target.checked;

        if (value && $scope.isLocAlreadySelected) {
          event.target.checked = false;
          current.isSelected = false;
          $scope.notify('error', 'An Employment can\'t have multiple locations');
          return;
        }
        else if(!value && !$scope.isLocAlreadySelected)
          $scope.isLocAlreadySelected = true;
        else
          $scope.isLocAlreadySelected = false;



       if(level === 1) {
          $scope.updatedData.data.forEach(function(region, index, array) {
            region.locations.forEach(function(location, index, array) {
              if (location.loc_ID === current.loc_ID) {

                  if (value) {
                    // if($scope.count < 1)
                      $scope.isLocAlreadySelected = true;
                      location.isSelected = value;

                    region.locations.forEach(function(p, i, a) {
                      if (p.isSelected) {
                        pCounter++;
                      }
                    });
                    if (value) {
                      if (pCounter > 0) {
                        region.isSelected = value;
                      }
                    } else {
                      if (pCounter <= 0) {
                        region.isSelected = value;
                      }
                    }
                    $scope.count++;
                  } else if (!value) {
                    $scope.isLocAlreadySelected = false;
                    location.isSelected = value;
                    region.locations.forEach(function(p, i, a) {
                      if (p.isSelected) {
                        pCounter++;
                      }
                    });
                    if (value) {
                      if (pCounter > 0) {
                        region.isSelected = value;
                      }
                    } else {
                      if (pCounter <= 0) {
                        region.isSelected = value;
                      }
                    }
                    $scope.count--;
                  }

              }
            });
          });
        } else if (level === 0) {
          $scope.updatedData.data.forEach(function(region, index, array) {
            region.locations.forEach(function(location, index, array) {
              if (location.sub_areas.length > 0) {
                location.sub_areas.forEach(function(sub, index, array) {
                  if (sub.loc_ID === current.loc_ID) {
                    if (value) {
                      $scope.isLocAlreadySelected = true;
                    }
                    else if(!value)
                      $scope.isLocAlreadySelected = false;

                    sub.isSelected = value;
                    location.sub_areas.forEach(function(s, i, a) {
                      if (s.isSelected) {
                        sCounter++;
                      }
                    });
                    if (value) {
                      if (sCounter > 0) {
                        region.isSelected = value;
                        location.isSelected = value;
                      }
                    } else {
                      if (sCounter <= 0) {
                        location.isSelected = value;
                        region.locations.forEach(function(p, i, a) {
                          if (p.isSelected) {
                            pCounter++;
                          }
                        });
                        if (value) {
                          if (pCounter > 0) {
                            region.isSelected = value;
                          }
                        } else {
                          if (pCounter <= 0) {
                            region.isSelected = value;
                          }
                        }
                      }
                    }
                    if (value) {
                      $scope.count++;
                    } else {
                      $scope.count--;
                    }
                  }
                });
              }
            });
          });
        }
      };

      $scope.save = function() {
        var chosenLocations = $scope.updatedData.data,
            linearizedLocations = [];
        chosenLocations.forEach(function(location, index, array) {
            if (location.isSelected) {
                location.locations.forEach(function(loc, index, array) {
                    if (loc.isSelected) {
                        if (!loc.hasChild) {
                            linearizedLocations.push(loc);
                        }
                        loc.sub_areas.forEach(function(sub, index, array) {
                            if (sub.isSelected) {
                                linearizedLocations.push(sub);
                            }
                        });
                    }
                });
            }
        });

        if(_.isEmpty(linearizedLocations)){
          $scope.notify("info", "It is mandatory for a work experience to have a location");
          return;
        }

        $modalInstance.close(linearizedLocations);
      };
      $scope.cancel = function() {
        $modalInstance.dismiss("cancel");
      };
}



// WEBPACK FOOTER //
// ./scripts/candidate-profile/employment-history/employmentHistoryLocationCtrl.js